<ng-container *ngIf="flashMessage">
  <div
    class="flash-message-stripe"
    [ngClass]="!flashMessage.colorCustom && flashMessage.color && 'bg-'+flashMessage.color"
    [ngStyle]="flashMessage.colorCustom && {'color': flashMessage.colorCustom }"
  >
    <h4 style="margin-bottom: 1rem;">{{ flashMessage.title }}</h4>
    <p [innerHTML]="flashMessage.text"></p>
    <button
      class="close-button btn btn-pollstar btn-outline-white btn-pollstar-small "
      (click)="close()"
    >X</button>
  </div>
</ng-container>
